import React from 'react';
import {ClickAwayListener, Paper, Popper, Typography} from '@mui/material';
import {
  bool,
  func,
  instanceOf,
  node,
  object,
  oneOfType,
  string,
} from 'prop-types';

const LIST_WIDTH = 230;

const MapPopper = ({
  children,
  title,
  open,
  anchorEl,
  placement = 'left-start',
  onClose,
  sx,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      sx={{
        zIndex: theme => theme.zIndex.modal,
      }}
    >
      <Paper
        sx={[
          {
            padding: 1.0,
            marginRight: 0.5,
            width: LIST_WIDTH,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <ClickAwayListener onClickAway={onClose}>
          <div>
            <Typography variant="subtitle1">{title}</Typography>
            {children}
          </div>
        </ClickAwayListener>
      </Paper>
    </Popper>
  );
};

MapPopper.propTypes = {
  children: node,
  title: string,
  open: bool,
  anchorEl: oneOfType([node, instanceOf(Element)]),
  placement: string,
  sx: object,
  onClose: func,
};

export default MapPopper;
